import UIDs from "../../../UIDs";

const uid = UIDs.layouts.practice;

const ActionTypes = {
    LOGOUT: `${uid}.logout`,
    TRY_LOAD_SESSION: `${uid}.tryLoadSession`,
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
};

export { ActionTypes };
